import Vue from 'vue'
import ToggleSwitch from './ToggleSwitch.vue'

Vue.component('ToggleSwitch', ToggleSwitch)

export { ToggleSwitch }

export default ToggleSwitch
